<template>
  <div class="property">
    <header>
      <a href="#back" @click.prevent="$router.go(-1)">
        <img :src="require('@/assets/images/chevron_left.svg')" class="icon" />
      </a>
      <img v-lazy="property.cover" />
    </header>
    <ul class="attributes">
      <li v-if="parseInt(property.price.rent) > 0">
        <span class="text">Aluguel</span>
        <span class="spotlight"
        >R${{ property.price.rent }}
        </span>
      </li>
      <li v-if="parseInt(property.price.sale) > 0" class="right">
        <span class="text">Venda</span>
        <span class="spotlight"
        >R${{ property.price.sale }}
        </span>
      </li>
    </ul>
    <section>
      <h1>{{ property.title }}</h1>
      <p>{{ property.description }}</p>

      <div class="group-start"></div>
      <div class="group">
        <div class="title">Categorias</div>
        <ul>
          <li v-for="category in property.categories" :key="category.slug">{{ category.name }}</li>
        </ul>
      </div>
      <div class="group assembles">
        <ul>
          <li><img class="icon icon-dark" :src="require('@/assets/images/bathroom.svg')"/>
            {{ property.attributes.bathrooms }}</li>
          <li><img class="icon icon-dark" :src="require('@/assets/images/bedroom.svg')"/>
            {{ property.attributes.suites }}/{{ property.attributes.bedrooms }}</li>
          <li><img class="icon icon-dark" :src="require('@/assets/images/garage.svg')"/>
            {{ property.attributes.garages }}</li>
          <li><img class="icon icon-dark" :src="require('@/assets/images/icon_sas_darken.svg')"/>
            {{ property.area.total }}/{{ property.area.util }}</li>
        </ul>
      </div>
      <div class="group address">
        <div class="title">Endereço</div>
        <p>{{ property.address.street }}, {{ property.address.number }}<br />
        {{ property.address.zipcode }}, {{ property.address.neighborhood }}<br />
        {{ property.address.city }}/{{ property.address.state }}</p>
        <button v-if="property.map.lng"
                @click.prevent="openMap" class="button-round button-secondary action">
          <img class="icon" :src="require('@/assets/images/link.svg')" />
        </button>
      </div>
      <div class="group">
        <div class="title">Local da chave</div>
        <p>{{ property.key_location || 'Não informado' }}</p><br /><br />

        <div class="title">Descrição interna</div>
        <p>{{ property.internal_description || 'Não informado' }}</p><br /><br />

        <div class="title">Para o corretor</div>
        <p>{{ property.broker_description || 'Não informado' }}</p>
      </div>
      <div class="group">
        <div class="title">Proprietário</div>
        <ul>
          <li>{{ property.client.name }}</li>
          <li>E-mail: {{ property.client.email }}</li>
          <li>Fone: {{ property.client.telefone }}</li>
          <li>Celular: {{ property.client.cell }}</li>
        </ul>
        <p>{{ property.client.address.street }}, {{ property.client.address.number }}<br />
          {{ property.client.address.zipcode }}, {{ property.client.address.neighborhood }}<br />
          {{ property.client.address.city }}/{{ property.client.address.state }}</p>
      </div>
      <div class="group">
        <div class="title">Corretor</div>
        <ul>
          <li>{{ property.broker.name }}</li>
          <li>E-mail: {{ property.broker.email }}</li>
          <li>Fone: {{ property.broker.telefone }}</li>
          <li>Celular: {{ property.broker.cell }}</li>
        </ul>
      </div>
      <div class="group">
        <div class="title">Experiências</div>
        <ul>
          <li v-for="experience in property.experiences"
              :key="experience.slug">{{ experience.name }}</li>
        </ul>
      </div>
      <div class="group">
        <div class="title">Atributos</div>
        <ul>
          <li v-for="tag in property.tags"
              :key="tag.slug">{{ tag.name }}</li>
        </ul>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Property',
  beforeCreate() {
    this.$store.commit('headerModeAuth');
    this.$store.commit('headerBack', true);
    this.$store.commit('headerSearch', false);
  },
  beforeDestroy() {
    this.$store.commit('headerBack', false);
  },
  computed: {
    property() {
      const { propertyId } = this.$route.params;
      const { properties } = this.$store.state;
      return properties.find((property) => property.id === parseInt(propertyId, 10));
    },
  },
  methods: {
    openMap() {
      const { propertyId } = this.$route.params;
      this.$router.push({
        name: 'auth.property.map',
        params: {
          propertyId,
        },
      });
    },
    openPhotos() {
      const { propertyId } = this.$route.params;
      this.$router.push({
        name: 'auth.property.photos',
        params: {
          propertyId,
        },
      });
    },
  },
};
</script>

<style scoped>
  .property{
    width: 100%;
    height: auto;
    min-height: 100vh;
    display: flex;
    overflow: hidden;
    position: absolute;
    left: 0;
    top: 0;
    background-color: var(--color-dashboard);
    z-index: 8000;
    padding: 0 30px;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
  }
  .property header{
    width: calc(100% + 60px);
    height: 50vh;
    overflow: hidden;
  }
  .property header > img{
    width: 100%;
    height: 100%;
    object-fit: cover;
    background-image: linear-gradient(
      90deg,
      var(--color-secondary),
      var(--color-secondary-dark)
    );
  }
  .property header .icon{
    position: fixed;
    top: 10px;
    left: 10px;
    animation: menu-in .3s linear forwards;
    animation-delay: .8s;
    opacity: 0;
  }

  .attributes{
    list-style: none;
    width: 100%;
    height: 60px;
    border-radius: 30px;
    background-color: white;
    margin-top: -30px;
    box-shadow: 0 0 8px var(--color-secondary);
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
    padding: 0 20px;
  }
  .attributes li{
    display: flex;
    width: 100%;
    flex-direction: column;
    justify-content: center;
    align-items: stretch;
    text-align: left;
    flex: 1;
  }
  .attributes li.bigger{
    flex: 2;
  }
  .attributes li.right{
    text-align: right;
  }
  .text{
    font-size: .8rem;
    text-transform: uppercase;
    margin: 2px 0;
  }
  .spotlight{
    color: var(--color-secondary-dark);
    font-weight: bold;
    margin: 2px 0;
  }
  .property > section {
    text-align: left;
  }
  .group-start{
    margin-top: 60px;
  }
  .group{
    margin-top: -30px;
    margin-left: -30px;
    width: calc(100% + 60px);
    min-height: 80px;
    height: auto;
    background-color: white;
    position: relative;
    padding: 15px 30px 60px 30px;
    border-radius: 30px 30px 0 0;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-direction: column;
    box-shadow: 0 0 8px var(--color-secondary-light);
  }
  .group > .title{
    color: var(--color-secondary-light);
    text-transform: uppercase;
    letter-spacing: 2px;
    font-size: .8rem;
    font-weight: bold;
    margin-bottom: 5px;
  }
  .group > ul{
    list-style: none;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;
  }
  .group > ul > li{
    background-color: var(--color-dashboard);
    padding: 8px 20px;
    border-radius: 20px;
    margin: 0 5px 5px 0;
  }
  .action{
    position: absolute;
    right: 30px;
    bottom: 48px;
  }
  .assembles li{
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.6rem;
    font-weight: bold;
  }
  .assembles li img{
    width: 20px;
    margin-right: 10px;
  }

  @media only screen and (min-width: 600px) and (max-width: 900px) {
    .attributes{
      max-width: 360px;
    }
  }

  @media only screen and (min-width: 900px) {
    .attributes{
      max-width: 360px;
    }
  }
</style>
